import {pageData} from '../constants/pagedata';

const BASE_URL='https://www.gamestolearnenglish.com/';
const EMBED_CODE_HEAD="<iframe style='max-width: 800px; overflow: hidden; border: none;' src='";
const EMBED_CODE_TAIL="' width='100%' height='550px' scrolling='no'></iframe>";

export const makeLink=function(page:string, content:string[]){
	let pageDir=pageData[page].pageDir;
	if(content[0]===''){
		return BASE_URL+pageDir+'/';
	}else{
		if(content[1]==='site-long')return BASE_URL+pageDir+'/#sl/'+content[0]+'/';
		if(content[1]==='grammarbubbles')return BASE_URL+pageDir+'/#s/'+content[0]+'/';//not sure about this
		return BASE_URL+pageDir+'/#s/'+content[0]+'/';
	}
};

export const makeUserContentLink=function(page:string, usermail:string, content:string){
	if(page===''||pageData[page]===undefined)return '';
	let pageDir=pageData[page].pageDir;
	return BASE_URL+pageDir+'/#u/'+usermail+'/'+content+'/';
}

export const makeNoUserContentLink=function(page:string, imsList:string[], txtsList:string[], audioChosen:number){
	if(page===''||pageData[page]===undefined)return '';
	let pageDir=pageData[page].pageDir;
	let contentString="";
	for(let i=0;i<imsList.length;i++){
		contentString+=imsList[i]+txtsList[i].replace(/ /g, "%20");
		if(i<imsList.length-1)contentString+="+";
	}
	let audioOption='/audio='+audioChosen;
	return BASE_URL+pageDir+'/#l/'+contentString+audioOption+'/';
}

export const makeTaskLink=function(page:string,mail:string,title:string){
	let pageDir=pageData[page].pageDir;
	return BASE_URL+pageDir+'/#t/'+mail+'/'+title+'/';
};
  
export const makeTaskLinkWithPageDir=function(pageDir:string,mail:string,title:string){
	return BASE_URL+pageDir+'/#t/'+mail+'/'+title+'/';
};

export const makeEmbedCode=function(link:string){
	let hashSplit=link.split('#');
	let embedUrl='';
	if(hashSplit.length===1){
		embedUrl=hashSplit[0]+'embed.html';
	}else{
		embedUrl=hashSplit[0]+'embed.html'+'#'+hashSplit[1];
	}
	let embedCode=EMBED_CODE_HEAD+embedUrl+EMBED_CODE_TAIL;
	return embedCode;
};
  